import React, { Component } from 'react';

import routePaths from 'config/routes';
import getConfig from 'next/config';
import redirectTo from 'services/redirectTo';
import { PlatformEnums, UserStatusEnum } from 'src/shared/enums';
import { ReduxPageContext } from 'src/store';
import { useRouter } from 'next/router';

const { PLATFORM_TYPE } = getConfig().publicRuntimeConfig;

interface Props {
  initialData?: any;
}
export function privateRoute({
  canBePublic,
  platforms,
  hidden = false,
  initialAction,
  magentoComponent,
  salesforceComponent,
  validUserStatus,
  WrappedComponent,
}: {
  canBePublic?: boolean;
  platforms?: PlatformEnums[];
  hidden?: boolean;
  initialAction?: (
    accessToken: string,
    ctx: ReduxPageContext
  ) => Promise<{ data: any }>;
  magentoComponent?: boolean;
  salesforceComponent?: boolean;
  validUserStatus?: UserStatusEnum[];
  WrappedComponent: any;
}) {
  return class PrivateRoute extends Component<Props> {
    static async getInitialProps(ctx: ReduxPageContext) {
      const incorrectPlatform =
        platforms?.length && !platforms.includes(PLATFORM_TYPE);
      const user = ctx.store.getState().auth.user;
      const accessToken = ctx.store.getState().auth.accessToken;
      const userStatus = ctx.store.getState().auth.userStatus;
      const { magento, salesforce } = user || {};


      switch (true) {
        case incorrectPlatform:
        case hidden:
        case validUserStatus && !validUserStatus.includes(userStatus):
        case magentoComponent && !magento:
        case salesforceComponent && !salesforce:
          redirectTo(routePaths.INDEX, ctx);
          return null;
        case Boolean(initialAction) && canBePublic:
        case Boolean(initialAction) && Boolean(accessToken):
          const response = await initialAction(accessToken, ctx);
          if (!Boolean(response?.data)) {
            redirectTo(routePaths.ERROR, ctx);
            return;
          }
          return { initialData: response.data };
        default:
          return null;
      }
    }

    render() {
      const { initialData, ...propsWithoutAuth } = this.props;
      return (
        <WrappedComponent initialData={initialData} {...propsWithoutAuth} />
      );
    }
  };
}
